import __request__ from "routing/request";
export function parse(JSONbody) {
  return __request__("POST", "/messages/parse", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function analyze(index, string, analyzer) {
  return __request__("GET", `/messages/${index}/analyze`, null, { "analyzer": analyzer, "string": string }, {
    "Accept": ["application/json"]
  });
}
export function search(index, messageId) {
  return __request__("GET", `/messages/${index}/${messageId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
